import { api } from '../services/api';

const basePath = '/frotas';

type TUserAdminPortalRole =
  | 'ADMINISTRADOR'
  | 'ATENDIMENTO'
  | 'COORDENADOR'
  | 'MARKETING'
  | 'FINANCEIRO'
  | 'GERENCIAL'
  | 'COMERCIAL';

export interface IUserRefreshToken {
  ChallengeParameters: any;
  AuthenticationResult: {
    AccessToken: string;
    ExpiresIn: number;
    TokenType: string;
    IdToken: string;
  };
}

export interface IUserAccessData {
  cognitoResult: {
    ChallengeParameters: any;
    AuthenticationResult: {
      AccessToken: string;
      ExpiresIn: number;
      TokenType: 'Bearer';
      RefreshToken: string;
      IdToken: string;
    };
  };
  userData: IUserData;
}

export interface IUserData {
  id?: number;
  sub: string;
  name: string;
  email: string;
  phone: string;
  document: string;
  status: 'ATIVO' | 'BLOQUEADO';
  role: TUserAdminPortalRole;
  consult_balance: number;
  initial_consult_balance: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date | null;
}

export interface ISignInUser {
  email: string;
  password: string;
}

export interface ISignUpUser {
  name: string;
  email: string;
  phone: string;
  password: string;
  cpf?: string;
  status?: string;
  role: string;
}

export interface ICompletePasswordData {
  email: string;
  verificationCode: string;
  password?: string;
}

export async function signUp(dataObject: ISignUpUser): Promise<any> {
  const { data } = await api.post(`${basePath}/sign-up`, dataObject);

  return data;
}

export async function signIn(
  dataObject: ISignInUser,
): Promise<IUserAccessData> {
  const { data } = await api.post(`${basePath}/sign-in`, dataObject);
  return data;
}

export async function refreshToken(
  refreshToken: string,
): Promise<IUserRefreshToken> {
  const { data } = await api.post(`${basePath}/refresh-token`, {
    refreshToken,
  });
  return data;
}

export async function logout(AccessToken: string): Promise<any> {
  const { data } = await api.post(`${basePath}/logout`, {AccessToken});
  return data;
}

export async function forgotPassword(email: string): Promise<any> {
  const { data } = await api.post(`${basePath}/forgot-password`, { email });
  return data;
}

export async function completePasswordReset(
  completePasswordData: ICompletePasswordData,
): Promise<any> {
  const { data } = await api.post(
    `${basePath}/complete-password-reset`,
    completePasswordData,
  );
  return data;
}
